module.exports = __webpack_public_path__ + "img/pingjia2.b6c32171.png";